import clsx from 'clsx'
import { memo, type ReactNode, useMemo } from 'react'

import { type FvDateInput, fvDate, fvDateUtc } from '@fv/dates'

import type { TooltipProps } from './Tooltip.jsx'

export type FvDateProps = {
  val: FvDateInput
  utc?: boolean
  format?: string
  wrap?: boolean
}
export const FvDateDisplay = memo(function FvDate({
  val,
  utc = true,
  format = 'MMM D',
  wrap = false,
}: FvDateProps) {
  const date = useMemo(
    () => (utc ? fvDateUtc(val).local() : fvDate(val)).format(format),
    [val, utc, format],
  )
  if (!val) return null
  return (
    <span
      className={clsx({
        'whitespace-nowrap': !wrap,
      })}
    >
      {date}
    </span>
  )
})

type RelativeProps = {
  val: FvDateInput
  tooltip?: boolean
  tooltipComponent?: (props: TooltipProps) => ReactNode
}
export const FvRelativeDate = ({
  val,
  tooltip,
  tooltipComponent,
}: RelativeProps) => {
  if (!val) return null

  const date = fvDateUtc(val).local()
  const display = date.fromNow()
  if (!tooltip || !tooltipComponent) {
    return <span>{display}</span>
  }

  return tooltipComponent({
    label: date.format('YYYY-MM-DD h:mma'),
    children: <span>{display}</span>,
  })
}

export {
  FvDateDisplay as FvDate, // convenience alias
}
